var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoaccessimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 144,
    viewBox: "0 0 150 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.086 143.625H6.91406C3.09375 143.625 0 140.531 0 136.711V7.28906C0 3.46875 3.09375 0.375 6.91406 0.375H143.086C146.906 0.375 150 3.46875 150 7.28906V136.711C150 140.531 146.906 143.625 143.086 143.625Z",
    fill: "#34AFAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150 32.9297H0V7.28906C0 3.46875 3.09375 0.375 6.91406 0.375H143.086C146.906 0.375 150 3.46875 150 7.28906V32.9297Z",
    fill: "#34AFAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92188 32.9297H142.078V134.766H7.92188V32.9297Z",
    fill: "#F7F7F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5078 16.6641C44.5078 19.6875 42.0703 22.125 39.0469 22.125C36.0234 22.125 33.5859 19.6875 33.5859 16.6641C33.5859 13.6406 36.0234 11.2031 39.0469 11.2031C42.0703 11.2031 44.5078 13.6406 44.5078 16.6641Z",
    fill: "#83DAFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3203 16.6641C26.3203 19.6875 23.8828 22.125 20.8594 22.125C17.8359 22.125 15.3984 19.6875 15.3984 16.6641C15.3984 13.6406 17.8359 11.2031 20.8594 11.2031C23.8828 11.2031 26.3203 13.6406 26.3203 16.6641Z",
    fill: "#F4C95A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6953 16.6641C62.6953 19.6875 60.2578 22.125 57.2344 22.125C54.2109 22.125 51.7734 19.6875 51.7734 16.6641C51.7734 13.6406 54.2109 11.2031 57.2344 11.2031C60.2344 11.2031 62.6953 13.6406 62.6953 16.6641Z",
    fill: "#FF7058"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.805 20.7422H82.4062C80.1797 20.7422 78.3516 18.9375 78.3516 16.6875V16.6172C78.3516 14.3906 80.1562 12.5625 82.4062 12.5625H124.805C127.031 12.5625 128.859 14.3672 128.859 16.6172V16.7109C128.859 18.9375 127.031 20.7422 124.805 20.7422Z",
    fill: "#DADDE1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2422 84.2578C92.7187 84.2578 91.4766 82.9219 91.4766 81.3047V64.2656C91.4766 59.5547 89.7656 55.125 86.6484 51.7969C83.5313 48.4453 79.3828 46.6172 75 46.6172C65.9062 46.6172 58.5 54.5391 58.5 64.2656V81.3047C58.5 82.9453 57.2578 84.2578 55.7344 84.2578C54.2109 84.2578 52.9688 82.9219 52.9688 81.3047V64.2656C52.9688 51.2813 62.8594 40.6875 75 40.6875C80.8594 40.6875 86.3906 43.1484 90.5625 47.6016C94.7344 52.0313 97.0078 57.9609 97.0078 64.2656V81.3047C97.0078 82.9453 95.7656 84.2578 94.2422 84.2578Z",
    fill: "#41596B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2422 127.008H55.7578C50.8594 127.008 46.875 123.023 46.875 118.125V87.2344C46.875 82.3359 50.8594 78.3516 55.7578 78.3516H94.2422C99.1406 78.3516 103.125 82.3359 103.125 87.2344V118.125C103.125 123.023 99.1406 127.008 94.2422 127.008Z",
    fill: "#F1543F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.875 85.4766H103.125V119.859H46.875V85.4766Z",
    fill: "#FF7058"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3281 103.031L79.2422 113.461H70.7578L71.6719 103.031C70.0313 101.953 68.9297 100.078 68.9297 97.9453C68.9297 94.5938 71.6484 91.875 75 91.875C78.3516 91.875 81.0703 94.5938 81.0703 97.9453C81.0703 100.078 79.9687 101.953 78.3281 103.031Z",
    fill: "#41596B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoaccessimage);
export default __webpack_public_path__ + "static/media/noaccessimage.bd6ee7af8f5fc9b3ba2f5021fb4ba1b3.svg";
export { ForwardRef as ReactComponent };